
import { Injectable } from '@angular/core';
import { getSupabase } from '../firebase';
import { SupabaseClient } from '@supabase/supabase-js';

@Injectable({
  providedIn: 'root'
})
export class VideoCallService {
  private supabase: SupabaseClient | null = getSupabase();

  async createRoomAndGetTokens(prescriptionId: string): Promise<{ token: string, roomName: string }> {
    // FIX: Removed random suffix to ensure room persistence.
    // Users can rejoin the same room if they get disconnected.
    const roomName = `Med-${prescriptionId}`;
    return { token: '', roomName };
  }

  async sendCallInvitation(customerId: string, roomName: string): Promise<void> {
    if (!this.supabase) throw new Error("Database connection error");

    // ใช้ระบบ Targeted Channel
    const channelName = `customer-call-${customerId}`;
    const channel = this.supabase.channel(channelName, {
        config: { broadcast: { self: true, ack: true } }
    });

    return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
            this.supabase?.removeChannel(channel);
            reject(new Error(" signaling timeout"));
        }, 8000);

        channel.subscribe(async (status) => {
            if (status === 'SUBSCRIBED') {
                const response = await channel.send({
                    type: 'broadcast',
                    event: 'incoming-call',
                    payload: { roomName, timestamp: new Date().toISOString() }
                });

                if (response === 'ok') {
                    clearTimeout(timeout);
                    console.log(`[VideoCall] Invite sent successfully to ${channelName}`);
                    resolve();
                } else {
                    reject(new Error("Failed to broadcast signal"));
                }
            }
        });
    });
  }
}
